define('viewmodels/notfound',['plugins/router'], function (router) {
    return {
        convertRouteToHash: router.convertRouteToHash,
    };
});
